var Window = require('ember-window')

module.exports = Window.extend({
    template: require('../templates/components/approve-invoice-modal'),

    applyModalMask: false,

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    approveInvoice: null, // set when invoking the modal

    customActions: {
        closeEmber: function() {
            this.close()
        },
        approveInvoice: function(event) {
            this.approveInvoice(event)
        }
    }
})
